import React, { useCallback } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch } from "react-redux";
import { FormText } from "reactstrap";
import type { ThunkDispatchType } from "src/app/reducers/IMainAppState";
import { UploadMerchantLogo } from "src/merchants/actions/MerchantActionCreators";
import {
  FileUploadForm,
  type IFileUploadFormProps,
} from "src/shared/forms/file/FileUploadForm";

export interface IMerchantLogoUploadFormProps
  extends Pick<IFileUploadFormProps, "validationDisabled" | "tooltip"> {
  onLogoChange: (logoUrl: string) => void;
}

export default function MerchantLogoUploadForm({
  onLogoChange,
  ...props
}: IMerchantLogoUploadFormProps) {
  const dispatch = useDispatch<ThunkDispatchType>();
  const handleUploadLogo = useCallback(
    async (
      logoFile: File,
      handleUploadProgress?: (progressEvent: ProgressEvent) => void,
    ) => {
      const { logoUrl } = await dispatch(
        UploadMerchantLogo(logoFile, handleUploadProgress),
      );
      return logoUrl;
    },
    [dispatch],
  );

  return (
    <FileUploadForm
      {...props}
      inputLabel={<FormattedMessage id="merchants.logo" />}
      submitLabel={<FormattedMessage id="merchants.form.logo.submit" />}
      onUploadFile={handleUploadLogo}
      onFileChange={onLogoChange}
    >
      <p>
        <FormText color="muted">
          <FormattedMessage
            id="merchants.logo.required"
            values={{ br: <br /> }}
          />
        </FormText>
      </p>
    </FileUploadForm>
  );
}
